module.exports = __webpack_public_path__ + "img/interact-teacher-btn_new.47aca52e.png";